import { FieldHelpTooltip } from '@components';
import { Group, Text } from '@mantine/core';

interface FieldLabelWithHelpProps {
  label: string;
  tooltip: string;
}

// Shared label-plus-help-icon markup so every field's tooltip looks and behaves identically
// instead of each form re-implementing the same Group/Text/Tooltip combination.
export const FieldLabelWithHelp: React.FC<FieldLabelWithHelpProps> = ({ label, tooltip }) => (
  <Group gap={4} wrap="nowrap">
    <Text fw={500} fz="sm">
      {label}
    </Text>
    <FieldHelpTooltip label={tooltip} />
  </Group>
);
